export default "__VITE_ASSET__6b$Q_3mJ__"